import { jsx as r } from "react/jsx-runtime";
import "../../utils/sectionPreview.js";
import "react";
import s from "clsx";
import "../Button/Button.js";
import { Space as c } from "../Space/Space.js";
import "next/link";
import "../../_chunks/RadioRatingStarButton.Brs_PIli.js";
import "js-cookie";
import "../Combobox/Combobox.js";
import "../Datepicker/Datepicker.js";
import "@portabletext/react";
import "../Grid/Col/Col.js";
import "react-is";
import "../IconButton/IconButton.js";
import "next/image";
import "../Input/Input.js";
import "@hookform/error-message";
import "../Modal/constants.js";
import "../Modal/ModalContent.js";
import "../Modal/ModalFooter.js";
import "../Modal/ModalHeader.js";
import "../Modal/ModalContext.js";
import "../RadioButton/RadioButton.js";
import "../Switch/Switch.js";
import '../../_assets/Divider.DuYLS7Gk.css';const l = "_divider_1lmyq_44", v = {
  divider: l
}, I = ({
  className: o,
  classNameContainer: m,
  top: t = 0,
  right: p = 0,
  bottom: d = 0,
  left: e = 0,
  color: i
}) => /* @__PURE__ */ r(c, { top: t, right: p, bottom: d, left: e, className: m, children: /* @__PURE__ */ r(
  "div",
  {
    className: s(v.divider, o),
    style: i ? { backgroundColor: i } : void 0,
    children: " "
  }
) });
export {
  I as Divider
};
